<template>
	<div :class="['question-answer-wrap', { compact }]">
		<div class="question">
			<div class="feedback-header">
				<ximg
					:src="avatarUrl"
					:style="avatarStyle"
					class="avatar-small pixelated"
					eager
					ariaLabel="user avatar"
					role="img"
				/>
				<div class="username-and-knighthood">
					<router-link
						v-if="question.user && question.user.isPublicProfile && ! question.isAnonymous"
						:to="userPath"
						class="username"
					>
						{{ question.user.username }}
					</router-link>
					<span v-else class="username">
						{{ question.user && ! question.isAnonymous ? question.user.username : 'No-Face' }}
					</span>
					<knighthood-icon v-if="question.user && question.user.knighthood > 0" />
				</div>

					<span
						v-if="question.user"
						class="level sub-title"
					>
						Lvl {{ question.user.rankLevel }} {{ question.user.avatar.class.title }}
					</span>

				<span class="posted sub-title">{{ postedString }}</span>
				<div v-if="! compact" class="votes">
					<span
						@click="vote(1)"
						class="vote vote-up"
						:class="{ active: usersVote > 0 }"
					>{{ question.upvotes }}</span>
					<span
						@click="vote(-1)"
						class="vote vote-down"
						:class="{ active: usersVote < 0 }"
					>{{ question.downvotes }}</span>
				</div>

			</div>
			<p :class="['text', { 'compact-feedback': compact }]">
				<template v-if="! compact">Fråga: </template>{{ this.question.text }}
			</p>
			<a v-if="canWriteComment && ! compact" class="fake-link reply" @click="writeAnswer">
				Svara {{ question.user && ! question.isAnonymous ? question.user.username : 'No-Face' }}
			</a>
		</div>
		<div class="answers">
			<hr v-if="isWritingAnswer">
			<question-answer-form v-if="isWritingAnswer" isReply :product="product" :question="question" @cancel="isWritingAnswer = false" />
			<answer v-for="answer in computedAnswers" :key="answer.id" :answer="answer" :userVotes="userVotes" />
			<div v-if="question.replies && question.replies.length && question.replies.length > 1" class="show-more">
				<a v-if="! showAllReplies" @click="showAllReplies = true">
					Visa fler svar
				</a>
				<a v-else @click="showAllReplies = false">
					Visa färre svar
				</a>
			</div>
		</div>
		<hr>
	</div>
</template>
<script>
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import svLocale from 'date-fns/locale/sv';
import alert from 'alert';
import store from 'datastore';
import memberUtils from 'utils/member';
import { mapGetters, mapState } from 'vuex';
import { memberRoute } from 'utils';

export default {
	props: {
		question: {
			type: Object,
			default: null,
		},
		product: {
			type: Object,
			default: null,
		},
		userVotes: {
			type: Object,
			default: function () {
				return {};
			},
		},
		compact: {
			type: Boolean,
			default: false,
		},
	},
	data () {
		return {
			store,
			showAllReplies: false,
			isWritingAnswer: false,
		};
	},
	computed: {
		hasMoreReplies () {
			return this.computedAnswers.length < this.question.totalReplyCount;
		},
		userPath () {
			if (this.question.user) {
				return this.$router.route(memberRoute(this.question.user, 'member.achievements'));
			} else {
				return null;
			}
		},
		...mapState({
			user: state => state.user,
		}),
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
			languageCode: 'i18n/languageCode',
			isDark: 'user/isDark',
		}),
		computedAnswers () {
			let answers = [];

			if (this.question.replies && this.question.replies.length) {
				if (! this.showAllReplies) {
					// Sort question on most upvotes.
					this.question.replies.sort((replyOne, replyTwo) => {
						return (replyOne.upvotes - replyOne.downvotes) < (replyTwo.upvotes - replyTwo.downvotes) ? 1 : -1;
					});
					answers.push(this.question.replies[0]);
				} else {
					// Sort questions on date created.
					this.question.replies.sort((replyOne, replyTwo) => {
						return replyOne.createdAt > replyTwo.createdAt ? 1 : -1;
					});
					answers = this.question.replies;
				}
			}

			return answers;
		},
		postedString () {
			const string = distanceInWordsToNow(this.question.createdAt * 1000, {
				locale: svLocale,
				addSuffix: true,
				onlyNumeric: true,
			});
			return string;
		},
		avatarStyle () {
			return memberUtils.avatarStyle(this.question);
		},
		avatarUrl () {
			return memberUtils.avatarUrl(this.question);
		},
		usersVote: {
			get () {
				return this.userVotes[this.question.id] || 0;
			},
			set (val) {
				Vue.set(this.userVotes, this.question.id, val);
			},
		},
		canWriteComment () {
			return store.getters['comments/canWriteComment'];
		},
		isLoggedIn () {
			return store.getters['user/isLoggedIn'];
		},
	},
	methods: {
		writeAnswer () {
			if (! this.isLoggedIn) {
				alert('Du måste vara inloggad för att kunna svara på frågor!');
				return;
			}

			this.isWritingAnswer = true;
		},
		vote (newVote) {
			if (! this.isLoggedIn) {
				alert('Endast medlemmar kan rösta!');
				return;
			}
			if (this.usersVote === 1) {
				this.question.upvotes--;
			} else if (this.usersVote === -1) {
				this.question.downvotes--;
			}
			if (this.usersVote === newVote) {
				newVote = 0;
			}
			this.usersVote = newVote;
			if (newVote === 1) {
				this.question.upvotes++;
			} else if (newVote === -1) {
				this.question.downvotes++;
			}
			waja.put('comment/' + this.question.id + '/vote')
				.data({
					vote: newVote,
				})
				.on('success', res => {
					alert('Tack för din röst!');
				})
				.go();
			//@TODO error handler
		},
	},
};
</script>
